import React, { useEffect, useState } from 'react';
import Draggable from 'react-draggable';
import './notes.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsH, faChevronDown, faChevronRight, faClose } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { setNoteToggle } from '@src/middleware/redux/reducers/note.reducer';
import ReactQuill from 'react-quill';

// Floating "new note" composer - shared by every module's NotesTab and by the
// schedule duty-notes tab (editDutyNoteTab.jsx). It only knows how to collect the
// note body; saving/closing is entirely up to whoever passes in `handelNote`/`loading`.
const NOTES_WIDTH = 640;
const NOTES_WIDTH_EXPANDED = 1000;
const NOTES_HEIGHT = 560;
const NOTES_HEIGHT_COLLAPSED = 54;
const NOTES_MARGIN = 100;
// keep a little breathing room on short screens so the footer buttons never go off-screen
const NOTES_VIEWPORT_GAP = 40;

const clamp = (value, max) => Math.min(Math.max(value, 0), Math.max(0, max));

const openHeight = () => Math.min(NOTES_HEIGHT, window.innerHeight - NOTES_VIEWPORT_GAP);

export const Notes = ({ handelNote, loading }) => {
    const [position, setPosition] = useState(() => ({
        x: Math.max(0, window.innerWidth - NOTES_WIDTH - 400),
        y: Math.max(0, window.innerHeight - openHeight() - NOTES_MARGIN),
    }));

    const handleDrag = (e, ui) => {
        setPosition({ x: ui.x, y: ui.y });
    };
    const [collapse, setCollapse] = useState(false);
    const [width, setWidth] = useState(false);
    const dispatch = useDispatch();

    const [value, setValue] = useState("");

    useEffect(() => {
        if (value == "<p><br></p>") {
            setValue("");
        }
    }, [value]);

    const close = () => dispatch(setNoteToggle(false));

    const panelWidth = width ? NOTES_WIDTH_EXPANDED : NOTES_WIDTH;
    const panelHeight = collapse ? NOTES_HEIGHT_COLLAPSED : openHeight();
    const maxX = window.innerWidth - panelWidth;
    const maxY = window.innerHeight - panelHeight;
    // clamp whatever position dragging left us at against the panel's *current*
    // size - keeps it fully on-screen even right after expanding/collapsing
    const dockedPosition = { x: clamp(position.x, maxX), y: clamp(position.y, maxY) };

    return (
        // remounted whenever the panel's own footprint changes so the freshly
        // clamped position becomes its new starting point (an uncontrolled
        // <Draggable> otherwise ignores position/bounds changes after mount)
        <Draggable
            key={`${width}-${collapse}`}
            onDrag={handleDrag}
            handle='.notes-header'
            defaultPosition={dockedPosition}
            bounds={{ left: 0, top: 0, right: Math.max(0, maxX), bottom: Math.max(0, maxY) }}
        >
            <div className="notes-main"
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    zIndex: 99999,
                    overflow: "hidden",
                    height: panelHeight,
                    width: panelWidth,
                }}>
                <div className="notes-header">
                    <span className="notes-header-title">
                        <FontAwesomeIcon
                            className='svg-icon'
                            icon={collapse ? faChevronRight : faChevronDown}
                            onClick={() => setCollapse(!collapse)}
                        />
                        New note
                    </span>
                    <span>
                        <FontAwesomeIcon icon={faArrowsH} onClick={() => setWidth(!width)} className='svg-icon dblarrow' />
                        <FontAwesomeIcon onClick={close} className='svg-icon' icon={faClose} />
                    </span>
                </div>

                <div className="notes-body">
                    <ReactQuill theme="snow" value={value} onChange={setValue} placeholder="Log a note…" />
                </div>

                <div className="note-footer">
                    <button
                        onClick={() => handelNote(value)}
                        disabled={value?.length < 1 || loading}
                        className={value?.length < 1 || loading ? 'note-btn-primary note-btn-disabled' : 'note-btn-primary'}
                    >
                        Save note
                    </button>
                    <button className="note-btn-secondary" onClick={close}>Cancel</button>
                </div>

            </div>
        </Draggable>
    );
};
